import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateUser, deleteUser } from "./../../../REDUX/Models/users.Model";
import { editUser, signOut } from "./../../../REDUX/Slices/users.Slice";
import "./index.scss";

export default function Settings(props) {
  const {
    id,
    first_name,
    last_name,
    user_name,
    email,
    location,
    bio,
    facebook,
    twitter,
    whatsapp,
  } = useSelector((state) => state.userData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    first_name,
    last_name,
    user_name: user_name,
    email: email,
    location,
    bio,
    facebook,
    twitter,
    whatsapp,
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[^\s]{8,}$/;

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!passwordRegex.test(user.password)) {
      toast.error(
        "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، ورمز خاص."
      );
      return;
    }

    const sanitizedUser = Object.fromEntries(
      Object.entries(user).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );

    const invalidFields = Object.entries(sanitizedUser).filter(
      ([key, value]) =>
        ["first_name", "last_name"].includes(key) && value === ""
    );

    if (invalidFields.length > 0) {
      toast.error(
        "الرجاء عدم ترك الحقول الأساسية فارغة أو تحتوي على مسافات فقط."
      );
      return;
    }

    updateUser(id, sanitizedUser)
      .then((res) => {
        if (!res?.data?.user?.response) {
          toast.error("الرد غير متوقع من السيرفر");
          return;
        }

        dispatch(
          editUser({
            response: res.data.user.response,
            token: res.data.user.token,
          })
        );
        toast.success("تم تعديل البيانات بنجاح");
        setTimeout(() => {
          navigate("/loading");
        }, 1500);
      })
      .catch(() => {
        toast.error("خطأ في تحديث البيانات");
        dispatch(signOut());
      });
  };

  const handleDelete = () => {
    if (!window.confirm("هل انت متأكد من حذف حسابك؟")) return;
    deleteUser(id).then(() => dispatch(signOut()));
  };

  return (
    <>
      {props.hidden === true && (
        <div className="dashboard-settings">
          <div className="container">
            <div className="header">
              <h2> الاعدادات</h2>
            </div>
            <div className="row">
              <form className="dashboard-form" onSubmit={handleSubmit}>
                <div className="form-columns">
                  <div className="form-column">
                    <h3>معلومات الحساب</h3>

                    <div className="form-group">
                      <label>
                        <i className="fas fa-user"></i> الاسم الأول
                      </label>
                      <input
                        type="text"
                        name="first_name"
                        value={user.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>
                        <i className="fas fa-user"></i> الاسم الأخير
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        value={user.last_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group password-group">
                      <label>
                        <i className="fas fa-lock"></i> كلمة المرور
                      </label>
                      <div className="password-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={user.password}
                          onChange={handleChange}
                          required
                        />
                        <i
                          className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"} toggle-icon`}
                          onClick={() => setShowPassword((prev) => !prev)}
                        ></i>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>
                        <i className="fas fa-map-marker-alt"></i> الموقع
                      </label>
                      <input
                        type="text"
                        name="location"
                        value={user.location}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>
                        <i className="fas fa-info-circle"></i> نبذة عنك
                      </label>
                      <textarea
                        name="bio"
                        value={user.bio}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    <div className="form-buttons">
                      <button type="submit" className="submit-btn">
                        <i className="fas fa-edit"></i> تعديل
                      </button>
                    </div>
                  </div>

                  <div className="form-column">
                    <h3>معلومات التواصل الاجتماعي</h3>

                    <div className="form-group">
                      <label>
                        <i className="fab fa-facebook"></i> رابط فيسبوك
                      </label>
                      <input
                        type="text"
                        name="facebook"
                        value={user.facebook}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>
                        <i className="fab fa-twitter"></i> رابط تويتر
                      </label>
                      <input
                        type="text"
                        name="twitter"
                        value={user.twitter}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>
                        <i className="fab fa-whatsapp"></i> رقم واتساب
                      </label>
                      <input
                        type="number"
                        name="whatsapp"
                        value={user.whatsapp}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-buttons">
                      <button
                        type="button"
                        className="delete-btn"
                        onClick={handleDelete}
                      >
                        <i className="fas fa-trash-alt"></i> حذف الحساب
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-left" autoClose={3000} hideProgressBar />
    </>
  );
}
